import { ModalAlertUI } from './ModalAlert.Presenter';
import { useRecoilValue } from 'recoil';
import { ModalAlertDataType, modalAlertData } from 'recoil/modalAlert';
import React from 'react';

export const ModalAlertContainer = React.memo(function ModalAlertContainer() {
  const modalAlert = useRecoilValue<ModalAlertDataType>(modalAlertData);
  return <ModalAlertUI {...modalAlert} />;
});
